export const SUITS = ["♣", "♦", "♥", "♠"];
export const SUIT_NAMES = ["clubs", "diamonds", "hearts", "spades"];
export const RANKS = ["", "A", "2", "3", "4", "5", "6", "7", "8", "9", "10", "J", "Q", "K"];
export const rank = (c) => (c % 13) + 1;
export const suit = (c) => Math.floor(c / 13);
export const face = (c) => `${RANKS[rank(c)]}${SUITS[suit(c)]}`;
export const isRed = (c) => suit(c) === 1 || suit(c) === 2;
/** Card value under the October rules: A = 15, court = 10, numbers face value. */
export const cardValue = (c) => (rank(c) === 1 ? 15 : Math.min(rank(c), 10));
export const cardId = (suitLetter, r) => "CDHS".indexOf(suitLetter) * 13 + r - 1;
//# sourceMappingURL=cards.js.map